export default "__VITE_ASSET__C3Ys$GvF__"